import {
    SynopticTemplateNode,
    SynopticTemplateNodeChildrenSelectionType,
    SynopticTemplateNodeType
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import Tree, { LiquorTreeNode, LiquorTreeNodeStructure, LiquorTreeOptions } from 'liquor-tree'
import { StrictNullable } from '@/shared/types/app.types'

export type SynopticTemplateTreeNodeStructure = LiquorTreeNodeStructure<SynopticTemplateNode, SynopticTemplateTreeNodeStructure>
export type SynopticTemplateTreeNode = LiquorTreeNode<SynopticTemplateNode, SynopticTemplateTreeNode, SynopticTemplateTreeNode>

export const defaultSynopticTemplateTreeNodeStructure =
    (): SynopticTemplateTreeNodeStructure => ({
        text: '',
        data: {
            nodeType: SynopticTemplateNodeType.TITLE,
            allowsChildrenSelection: SynopticTemplateNodeChildrenSelectionType.NONE,
            text: '',
            code: '',
            morphologicCodeId: null,
            topographicCodeId: null,
            required: false,
            children: null
        }
    })

export interface ConfigurationTemplatesSynopticTemplatesModalStructureState {
    tree: StrictNullable<Tree>
    treeOptions: LiquorTreeOptions
    checkedTreeNodes: SynopticTemplateTreeNode[]
    selectedTreeNode: StrictNullable<SynopticTemplateTreeNode>
    operationsCount: number
}
export const initialConfigurationTemplatesSynopticTemplatesModalStructureState =
    (): ConfigurationTemplatesSynopticTemplatesModalStructureState => ({
        tree: null,
        treeOptions: {
            checkbox: true,
            autoCheckChildren: false,
            parentSelect: true,
            multiple: false,
            propertyNames: {
                id: 'code'
            }
        },
        checkedTreeNodes: [],
        selectedTreeNode: null,
        operationsCount: 0
    })
